<div class="p-6">
  <div class="flex gap-4">
    <div class="w-1/4 flex gap-2">
      <div class="flex items-end pb-2">
        <button
          class="py-2 px-2 h-[38px] w-[38px] transition-all duration-300 ease-in-out flex justify-center items-center rounded-md border-gray-200 border bg-white disabled:bg-slate-50 disabled:text-slate-300 hover:bg-theme-primary hover:border-theme-primary hover:text-white"
          (click)="previous()"
          [disabled]="isPreviousDisabled()"
        >
          <lucide-icon size="16" [name]="ChevronLeft"></lucide-icon>
        </button>
      </div>
      <app-input-group>
        <label appLabel>{{ 'chargeprices.startDate' | translate }}</label>
        <input type="date" appInput [(ngModel)]="startDate" [min]="minStartDate" (ngModelChange)="onStartDateChange($event)">
      </app-input-group>
      <div class="flex items-end pb-2">
        <button
          class="py-2 px-2 h-[38px] w-[38px] transition-all duration-300 ease-in-out flex justify-center items-center rounded-md border-gray-200 border bg-white disabled:bg-slate-50 disabled:text-slate-300 hover:bg-theme-primary hover:border-theme-primary hover:text-white"
          (click)="next()"
        >
          <lucide-icon size="16" [name]="ChevronRight"></lucide-icon>
        </button>
      </div>
    </div>
  </div>

  <app-card>
    @if (chargePriceDelta && chargeInformation) {
      <div class="flex gap-4">
        <div class="w-1/3">
          <app-value-details
            [collection]="priceCoreData"
            [data]="chargePriceDelta"
          ></app-value-details>
          @if (chargeInformation!.chargeType != 'Tariff' || chargeInformation!.observationPeriod != 'Hour') {
            <app-value-details
              [collection]="singlePriceData"
              [data]="chargePrices && chargePrices.length > 0 ? chargePrices[0] : null"
            ></app-value-details>
          }
        </div>
        @if (chargeInformation.observationPeriod === ObservationTimeSeriesPeriod.Hour) {
          <div class="w-1/3">
            @if (chargePrices && chargePrices.length >= 1) {
              <form [formGroup]="intervalForm">
                <table class="bg-gray-100 dark:bg-dark-hover border-collapse table-fixed w-full overflow-hidden rounded-t-md">
                  <thead>
                  <tr>
                    <th
                      class="w-1/3 bg-gray-100 dark:bg-dark-hover px-2 py-1 rounded-t text-sm text-left font-normal text-primary dark:text-dark-text border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-b border-t">
                      {{ 'common.hour' |translate }}
                    </th>
                    <th
                      class="bg-gray-100 dark:bg-dark-hover px-2 py-1 rounded-t text-sm text-left font-normal text-primary dark:text-dark-text border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-b border-t">
                      {{ 'chargeprices.price' |translate }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                    @for (item of interval; track item) {
                      <tr class="odd:bg-white dark:odd:bg-dark-card even:bg-none">
                        <td
                          class="text-primary dark:text-dark-text font-normal text-sm py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
                          {{ item < 10 ? '0' + item : item }} - {{ item + 1 < 10 ? '0' + (item + 1) : item + 1 }}
                        </td>
                        <td
                          class="text-primary dark:text-dark-text py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
                          <input type="number" appInput [formControlName]="'hour_' + item"
                                 [readOnly]="true"/>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </form>
            }
          </div>
        }
      </div>
    }
  </app-card>
</div>
